// Share session-scoped credentials only with live same-origin tabs. Nothing is
// persisted in localStorage; separate profiles/private contexts have separate channels.
export function openBrowserSessionChannel() {
  if (!window.BroadcastChannel) return { request: async () => null, close: () => {} };
  const channel = new BroadcastChannel('insight-browser-session-v1');
  let resolvePending;
  let timer;
  channel.onmessage = ({ data }) => {
    if (data?.type === 'request') {
      const token = sessionStorage.getItem('token');
      if (token) channel.postMessage({ type: 'session', token });
    } else if (data?.type === 'session' && resolvePending) {
      const resolve = resolvePending;
      resolvePending = null;
      clearTimeout(timer);
      resolve(data.token);
    }
  };
  return {
    request: () => new Promise((resolve) => {
      resolvePending = resolve;
      channel.postMessage({ type: 'request' });
      timer = setTimeout(() => { resolvePending = null; resolve(null); }, 600);
    }),
    close: () => {
      clearTimeout(timer);
      if (resolvePending) resolvePending(null);
      channel.close();
    },
  };
}

// A non-credential identity scopes delayed cross-tab logout signals after refresh.
export function sessionIdentity(token) {
  try {
    const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
    return payload.sid || payload.jti || String(payload.exp);
  } catch (_) { return null; }
}
